export default __webpack_public_path__ + "static/preview_reviewaid-a0f61d9e8ff99560d78e54bd3f428eb8.png";